import { Link } from "react-router-dom";
import Seo from "../Seo";
import L from "../../constants/baysportLabels";
import { PRODUCT_DOCS } from "../../constants/productDocs";
import s from "../Legal/legalPage.module.css";

export default function ProductDocsPage() {
  const doc = PRODUCT_DOCS;

  return (
    <div className={s.page}>
      <Seo title={doc.title} description={doc.description} />
      <header className={s.header}>
        <Link to="/" className={s.brand}>
          {L.productName}
        </Link>
        <nav className={s.nav} aria-label="Документация">
          <Link to="/docs" className={s.navActive}>
            Документация ПО
          </Link>
          <Link to="/#pricing">Тарифы</Link>
          <Link to="/registraciya">Регистрация клуба</Link>
        </nav>
      </header>

      <main className={s.main}>
        <p className={s.updated}>Редакция от {doc.updatedAt}</p>
        <h1 className={s.title}>{doc.title}</h1>
        {doc.sections.map((section) => (
          <section key={section.heading} className={s.section}>
            <h2 className={s.heading}>{section.heading}</h2>
            {section.paragraphs.map((text, i) => (
              <p key={`${section.heading}-${i}`} className={s.p}>
                {text}
              </p>
            ))}
          </section>
        ))}
      </main>

      <footer className={s.footer}>
        <Link to="/">← На главную</Link>
      </footer>
    </div>
  );
}
